module.exports = __webpack_public_path__ + "img/nodereal.f2bfa9c7.svg";